"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KeyCodes;
(function (KeyCodes) {
    KeyCodes["Enter"] = "Enter";
})(KeyCodes = exports.KeyCodes || (exports.KeyCodes = {}));
